import React, { useEffect, useRef, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useDispatch, useSelector } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";

import DeleteMaterial from "./DeleteMaterial";
import CatalogProductDetailModal from "../Common/CatalogModal/CatalogProductDetailModal";

import MaterialHBModal from "./MaterialHBModal";
import {
  addMaterial,
  getMaterialList,
} from "../../../../redux/feature/customer_app/customerV1Slice";
import { SearchField } from "../../../../Components/formElements/SearchField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import ShowUploadImage from "./ShowUploadImage";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import ItemService from "../../../../services/customer_appCommonService";

const Material = () => {
  localStorage.setItem("menu", "Master");
  localStorage.setItem("submenu", "Material Master");

  const dispatch = useDispatch();

  let materialData = useSelector((state) => state?.customerV1?.material?.data);
  let materialTable = useSelector(
    (state) => state?.customerV1?.material?.pagination
  );

  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getNewPerPage, setNewPerPage] = useState(10);

  const [modalDeleteMaterial, setModalDeleteMaterial] = useState(false);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(null);
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);

  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getData, setData] = useState();
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // eslint-disable-next-line
  const [getFileViewData, setFileViewData] = useState(null);
  const target = useRef(null);

  const [filterType, setFilterType] = useState("");
const [selectedValue, setSelectedValue] = useState("");
const [subGroupValue, setSubGroupValue] = useState("");
const [searchCode, setSearchCode] = useState("");
const [groupToCodesMap, setGroupToCodesMap] = useState({});
const [categoryToSubCategoryMap, setCategoryToSubCategoryMap] = useState({});
const [codeToDescMap, setCodeToDescMap] = useState({});
const mapsBuilt = useRef(false);

//  ADD BEFORE columns = [
const filterTypeOptions = [
  { label: "Material Group", value: "materialGroup" },
  { label: "Material Group Code", value: "materialGroupCode" },
  { label: "Material Category Code", value: "materialCategoryCode" },
];
const materialGroupOptions = Object.keys(groupToCodesMap);
const materialGroupCodeOptions = [...new Set(Object.values(groupToCodesMap).flat())];
const subGroupOptions =
  filterType === "materialGroup" && selectedValue
    ? groupToCodesMap[selectedValue] || []
    : filterType === "materialCategoryCode" && selectedValue
    ? categoryToSubCategoryMap[selectedValue] || []
    : [];
const subFilterKeyMap = {
  materialGroup: "materialGroupCode",
  materialCategoryCode: "materialSubCategoryCode",
};


  const [activeFilters, setActiveFilters] = useState({});
  const [selectedMaterialGroup, setSelectedMaterialGroup] = useState("");
//eslint-disable-next-line  
const [filteredGroupCodeOptions, setFilteredGroupCodeOptions] = useState([]);

  // ✅ Dynamic dropdown data for MaterialHBModal
  const [existingGroups, setExistingGroups] = useState([]);
  const [existingGroupCodes, setExistingGroupCodes] = useState([]);
  const [existingCategories, setExistingCategories] = useState([]);
  const [existingSubCategories, setExistingSubCategories] = useState([]);

  // ✅ Full structured lists for ComboboxField in MaterialHBModal
  const [groupComboList, setGroupComboList] = useState([]);
  const [categoryComboList, setCategoryComboList] = useState([]);
  const [subCategoryComboList, setSubCategoryComboList] = useState([]);

  const columns = [
    {
      name: "Material",
      selector: (row) => row.productName || "--",
      cell: (row) => (
        <div
          className="flex justify-center items-center cursor-pointer"
          onClick={() => showAddProduct("DETAILS", row.documentNumber)}
        >
          <div className="w-75">
            <ShowUploadImage fileid={row?.materialImage} />
          </div>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Code",
      id: "materialCode",
      selector: (row) => row.productName || "--",
      cell: (row) => (
        <div className="flex justify-center items-center">
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialCode} </p>
            <p className="m-0 p-0 pt-1 fw-bold text-success">
              {row.materialDescription}{" "}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Unit",
      selector: (row) => row.unit || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.unit} </p>
        </div>
      ),
      sortable: true,
      width: "80px",
    },
    {
      name: "Unit Weight",
      selector: (row) => row.unitWeight || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.unitWeight} </p>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.unitPrice} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Material Grp ",
      id: "materialGroup",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.materialGroup} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Attachments",
      selector: (row) => row.materialAttachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center cursor-pointer"
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Details",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 150, hide: 200 }}
            overlay={
              <Tooltip
                id={`tooltip-${row.documentNumber}`}
                className="custom-tooltip"
                target={target.current}
              >
                <div style={{ textAlign: "left" }}>
                  <strong>Material GroupCode:</strong>{" "}
                  {row?.materialGroupCode || "--"}
                  <br />
                  <strong>Material Category:</strong>{" "}
                  {row?.materialCategory || "--"}
                  <br />
                  <strong>Suraface/Paint:</strong>{" "}
                  {row?.unitSurfacePaint || "--"}
                  <br />
                  <strong>Building Type:</strong>{" "}
                  {Array.isArray(row?.buildingType)
                    ? row.buildingType
                        .map((b) =>
                          typeof b === "object" ? b?.code || b?.name : b
                        )
                        .join(", ") || "--"
                    : row?.buildingType || "--"}
                  <br />
                  <strong>Components:</strong> {row?.componentKey || "--"}
                  <br />
                  <strong>Remarks:</strong> {row?.remarks || "--"}
                  <br />
                  <strong>Created By:</strong> {row?.createdBy || "--"}
                  <br />
                  <strong>Created Date:</strong> {row?.createdDate || "--"}
                  <br />
                  <strong>Updated Date:</strong> {row?.updatedDate || "--"}
                  <br />
                </div>
              </Tooltip>
            }
          >
            <button className="btn btn-light p-1 border-0" title="View Details">
              <i className="bi bi-eye fs-5 text-primary"></i>
            </button>
          </OverlayTrigger>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Edit",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            className="btn d-flex align-items-center w-100"
            onClick={() => showAddProduct("EDIT", row.documentNumber)}
          >
            <i className="bi bi-pencil-square pe-2"></i>
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button onClick={() => deleteMaterial(row)}>
            <i className="bi bi-trash text-danger fs-4" />
          </button>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
  ];

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const deleteMaterial = (data) => {
    setModalDeleteMaterial(true);
    setData(data);
    dispatch(addMaterial(data.documentNumber));
  };

  const showAddProduct = (mode, materialnumber) => {
    setModalShowAddProduct(mode);
    if (mode === "EDIT") {
      dispatch(addMaterial(materialnumber));
    } else if (mode === "DETAILS") {
      dispatch(addMaterial(materialnumber));
    } else {
      dispatch(addMaterial(""));
    }
  };

  const hideModal = () => {
    setModalDeleteMaterial(false);
    setModalShowAddProduct(null);
    setModalShowDetailProduct(false);
  };

  useEffect(() => {
    let obj = {
      queryName: "Get_MATERIAL_LIST",
      page: 1,
      per_page: 10,
    };
    dispatch(getMaterialList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_MATERIAL_LIST",
      page: page,
      per_page: getNewPerPage,
      rowFilter: activeFilters,
    };
    dispatch(getMaterialList(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_MATERIAL_LIST",
      page: page,
      per_page: newPerPage,
      rowFilter: activeFilters,
    };
    setNewPerPage(newPerPage);
    dispatch(getMaterialList(obj));
  };

  const handleSearchFuncApi = async () => {
    setActiveFilters({});
    setSelectedMaterialGroup("");
    let obj = {
      queryName: "Get_MATERIAL_LIST",
      page: 1,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getMaterialList(obj));
  };

  const handleFilterMain = () => {
  if (!filterType || !selectedValue) {
    alert("Please select a filter type and value");
    return;
  }
  const activeFilterKey = subGroupValue ? subFilterKeyMap[filterType] : filterType;
  const activeFilterValue = subGroupValue ? subGroupValue : selectedValue;

  const rowFilter =
    filterType === "materialGroup" && subGroupValue
      ? { $and: [{ $or: [
          { materialGroupCode: { $in: [subGroupValue] } },
          { materialCategoryCode: { $in: [subGroupValue] } },
          { materialSubCategoryCode: { $in: [subGroupValue] } },
        ]}]}
      : { $and: [{ [activeFilterKey]: { $in: [activeFilterValue] } }] };

  setActiveFilters(rowFilter);
  dispatch(getMaterialList({
    queryName: "Get_MATERIAL_LIST",
    page: 1,
    per_page: getNewPerPage,
    rowFilter,
  }));
};

const handleResetMain = () => {
  setFilterType("");
  setSelectedValue("");
  setSubGroupValue("");
  setSearchCode("");
  setActiveFilters({});
  dispatch(getMaterialList({
    queryName: "Get_MATERIAL_LIST",
    page: 1,
    per_page: getNewPerPage,
  }));
};

const handleSearchByCodeMain = () => {
  if (!searchCode.trim()) { alert("Please enter a material code"); return; }
  dispatch(getMaterialList({
    queryName: "Get_MATERIAL_LIST",
    page: 1,
    per_page: getNewPerPage,
    rowFilter: { $and: [{ materialCode: { $regex: searchCode.trim(), $options: "i" } }] },
  }));
};

const handleSearchKeyPressMain = (e) => {
  if (e.key === "Enter") handleSearchByCodeMain();
};

  const [filterShow, setFilterShow] = useState(false);
// eslint-disable-next-line
  const handleFilterData = async (filters) => {
    const rowFilter = filters.length > 0 ? { $and: filters } : {};
    setActiveFilters(rowFilter);

    const groupFilter = filters.find((f) => f.materialGroup);
    if (groupFilter && groupFilter.materialGroup) {
      let groupValue = groupFilter.materialGroup;
      if (groupFilter.materialGroup.$regex) {
        const regexStr = groupFilter.materialGroup.$regex || "";
        const match = regexStr.match(/\.\*(.+)\.\*/);
        groupValue = match ? match[1] : "";
      }
      setSelectedMaterialGroup(groupValue);
    } else {
      setSelectedMaterialGroup("");
    }

    const obj = {
      queryName: "Get_MATERIAL_LIST",
      page: 1,
      per_page: getNewPerPage,
      searchTerm: "",
      rowFilter,
    };
    dispatch(getMaterialList(obj));
  };

  const [filterDropdownData, setFilterDropdownData] = useState({
    allData: [],
    materialCode: [],
    materialGroup: [],
    materialGroupCode: [],
    materialCategory: [],
  });

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        let obj = {
          queryName: "Get_MATERIAL_LIST",
          page: 1,
          per_page: 999999,
        };
        const res = await ItemService.generateCustomerQuery(obj);
        const data = res?.data || [];

        // ── Filter dropdown data ──────────────────────────────────────
        const uniqueGroups = [
          ...new Set(data.map((d) => d.materialGroup).filter(Boolean)),
        ];
        const uniqueGroupCodes = [
          ...new Set(data.map((d) => d.materialGroupCode).filter(Boolean)),
        ];

        setFilterDropdownData({
          allData: data,
          materialCode: [
            ...new Set(data.map((d) => d.materialCode).filter(Boolean)),
          ],
          materialGroup: uniqueGroups,
          materialGroupCode: uniqueGroupCodes,
          materialCategory: [
            ...new Set(data.map((d) => d.materialCategory).filter(Boolean)),
          ],
        });

        // ── Simple string arrays ──────────────────────────────────────
        setExistingGroups(uniqueGroups);
        setExistingGroupCodes(uniqueGroupCodes);
        setExistingCategories([
          ...new Set(data.map((d) => d.materialCategory).filter(Boolean)),
        ]);
        setExistingSubCategories([
          ...new Set(data.map((d) => d.materialSubCategory).filter(Boolean)),
        ]);

        // ── Group ComboList ───────────────────────────────────────────
        const groupSeen = new Set();
        const groupList = [];
        data.forEach((d) => {
          if (d.materialGroup && d.materialGroupCode && !groupSeen.has(d.materialGroupCode)) {
            groupSeen.add(d.materialGroupCode);
            groupList.push({
              id: groupList.length + 1,
              name: d.materialGroup,
              code: d.materialGroupCode,
              description: d.materialGroupDesc || d.materialGroup,
            });
          }
        });
        groupList.push({ id: groupList.length + 1, name: "Others", code: "OTHERS", description: "Others" });
        setGroupComboList(groupList);

        // ── Category ComboList (all — cascade happens inside modal) ───
        const catSeen = new Set();
        const catList = [];
        data.forEach((d) => {
          if (d.materialCategory && d.materialCategoryCode && !catSeen.has(d.materialCategoryCode)) {
            catSeen.add(d.materialCategoryCode);
            catList.push({
              id: catList.length + 1,
              name: d.materialCategory,
              code: d.materialCategoryCode,
              description: d.materialCategoryDesc || d.materialCategory,
            });
          }
        });
        catList.push({ id: catList.length + 1, name: "Others", code: "OTHERS", description: "Others" });
        setCategoryComboList(catList);

        // ── SubCategory ComboList (all — cascade happens inside modal) 
        const subSeen = new Set();
        const subList = [];
        data.forEach((d) => {
          if (d.materialSubCategory && d.materialSubCategoryCode && !subSeen.has(d.materialSubCategoryCode)) {
            subSeen.add(d.materialSubCategoryCode);
            subList.push({
              id: subList.length + 1,
              name: d.materialSubCategory,
              code: d.materialSubCategoryCode,
              description: d.materialSubCategoryDesc || d.materialSubCategory,
            });
          }
        });
        subList.push({ id: subList.length + 1, name: "Others", code: "OTHERS", description: "Others" });
        setSubCategoryComboList(subList);
if (!mapsBuilt.current && data.length > 0) {
  // ✅ Group → GroupCodes + CategoryCodes + SubCategoryCodes (modal తో same)
  const map = {};
  data.forEach((item) => {
    const group = item.materialGroup;
    const code = item.materialGroupCode;
    const catCode = item.materialCategoryCode;
    const subCatCode = item.materialSubCategoryCode;
    if (group) {
      if (!map[group]) map[group] = new Set();
      if (code) map[group].add(code);
      if (catCode) map[group].add(catCode);
      if (subCatCode) map[group].add(subCatCode);
    }
  });
  const finalMap = {};
  Object.keys(map).forEach((key) => { finalMap[key] = Array.from(map[key]); });
  setGroupToCodesMap(finalMap);

  // Category → SubCategory
  const catMap = {};
  data.forEach((item) => {
    const cat = item.materialCategoryCode;
    const sub = item.materialSubCategoryCode;
    if (cat) {
      if (!catMap[cat]) catMap[cat] = new Set();
      if (sub) catMap[cat].add(sub);
    }
  });
  const finalCatMap = {};
  Object.keys(catMap).forEach((key) => { finalCatMap[key] = Array.from(catMap[key]); });
  setCategoryToSubCategoryMap(finalCatMap);

  // Code → Description
  const descMap = {};
  data.forEach((item) => {
    if (item.materialGroupCode)
      descMap[item.materialGroupCode] = item.materialGroupDesc || "";
    if (item.materialCategoryCode)
      descMap[item.materialCategoryCode] = item.materialCategoryDesc || "";
    if (item.materialSubCategoryCode)
      descMap[item.materialSubCategoryCode] = item.materialSubCategoryDesc || "";
  });
  setCodeToDescMap(descMap);

  mapsBuilt.current = true;
}
      } catch (err) {
        console.error("Failed to fetch filter options", err);
      }
    };

    fetchFilterOptions();
  }, []);

  // Update filtered options when selectedMaterialGroup changes
  useEffect(() => {
    if (selectedMaterialGroup === "COLDROLLED") {
      setFilteredGroupCodeOptions(["HBEA", "INZ"]);
    } else if (selectedMaterialGroup && filterDropdownData.allData.length > 0) {
      const codes = [
        ...new Set(
          filterDropdownData.allData
            .filter((d) => d.materialGroup === selectedMaterialGroup)
            .map((d) => d.materialGroupCode)
            .filter(Boolean)
        ),
      ];
      setFilteredGroupCodeOptions(codes);
    } else {
      setFilteredGroupCodeOptions(filterDropdownData.materialGroupCode || []);
    }
  }, [
    selectedMaterialGroup,
    filterDropdownData.allData,
    filterDropdownData.materialGroupCode,
  ]);

  // const columnsForFilter = [
  //   {
  //     id: "materialCode",
  //     name: "Code",
  //     selectorKey: "materialCode",
  //   },
  //   {
  //     id: "materialGroup",
  //     name: "Material Group",
  //     selectorKey: "materialGroup",
  //     dropDown: true,
  //     staticOptions: filterDropdownData.materialGroup,
  //   },
  //   {
  //     id: "materialGroupCode",
  //     name: "Material Group Code",
  //     selectorKey: "materialGroupCode",
  //     dropDown: true,
  //     dependsOn: "materialGroup",
  //     staticOptions: filteredGroupCodeOptions,
  //   },
  // ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle"> Material Master</h2>
                <p className="subText">Material</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            {/* {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={filterDropdownData.allData}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )} */}
            {filterShow && (
  <Row className="mb-3 align-items-end g-2">

    <Col xs={12} md={2} className="commTopButtonRightLeftPadding">
      <label>Filter Type</label>
      <select
        className="form-select"
        value={filterType}
        onChange={(e) => {
          setFilterType(e.target.value);
          setSelectedValue("");
          setSubGroupValue("");
        }}
      >
        <option value="">-- Select Filter Type --</option>
        {filterTypeOptions.map((f) => (
          <option key={f.value} value={f.value}>{f.label}</option>
        ))}
      </select>
    </Col>

    {filterType && (
      <Col xs={12} md={2} className="commTopButtonRightLeftPadding">
        <label>{filterTypeOptions.find((f) => f.value === filterType)?.label}</label>
        <select
          className="form-select"
          value={selectedValue}
          onChange={(e) => { setSelectedValue(e.target.value); setSubGroupValue(""); }}
        >
          <option value="">-- Select --</option>
          {filterType === "materialGroup" &&
            materialGroupOptions.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
          {filterType === "materialGroupCode" &&
            materialGroupCodeOptions.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
          {filterType === "materialCategoryCode" &&
            Object.keys(categoryToSubCategoryMap).map((opt) => <option key={opt} value={opt}>{opt}</option>)}
        </select>
      </Col>
    )}

    {(filterType === "materialGroup" || filterType === "materialCategoryCode") &&
      selectedValue && subGroupOptions.length > 0 && (
      <Col xs={12} md={2} className="commTopButtonRightLeftPadding">
        <label>
          {filterType === "materialCategoryCode" ? "Sub Category Code" : "Sub Group (Code)"}
        </label>
        <select
          className="form-select"
          value={subGroupValue}
          onChange={(e) => setSubGroupValue(e.target.value)}
        >
          <option value="">
            -- All in {filterType === "materialCategoryCode" ? "Category" : "Group"} --
          </option>
          {subGroupOptions.map((opt) => (
            <option key={opt} value={opt}>
              {`${opt}${codeToDescMap[opt] ? ` - ${codeToDescMap[opt]}` : ""}`}
            </option>
          ))}
        </select>
      </Col>
    )}

    <Col xs={12} md={2} className="commTopButtonRightLeftPadding">
      <label>Search by Material Code & Press Enter ↵</label>
      <input
        type="text"
        className="form-control"
        placeholder="Enter material code..."
        value={searchCode}
        onChange={(e) => setSearchCode(e.target.value)}
        onKeyPress={handleSearchKeyPressMain}
      />
    </Col>

    <Col xs={12} md={2} className="commTopButtonRightLeftPadding d-flex flex-row gap-2 align-items-end">
      <button type="button" className="btn btn-primary flex-fill" onClick={handleFilterMain}>
        Filter
      </button>
      <button type="button" className="btn btn-danger flex-fill" onClick={handleResetMain}>
        Reset
      </button>
    </Col>

  </Row>
)}
            {/* material */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MD</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Material Details</span>
                      <span className="subHeaderTitle">Material</span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={3} md={3} lg={3} className="">
                        <button className="btnTable d-flex justify-content-center">
                          <p className="m-0 me-2">
                            <span className="mr-2">
                              <i className="bi bi-upload"></i>
                            </span>
                            Upload
                          </p>
                        </button>
                      </Col>
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable d-flex justify-content-center"
                          onClick={() => showAddProduct("CREATE")}
                        >
                          <p className="m-0 me-2">Material Creation</p>
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={materialData}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationTotalRows={materialTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <DeleteMaterial
        show={modalDeleteMaterial}
        onHide={() => hideModal()}
        data={getData}
      />

      {/* ✅ allMaterialData passed for cascade filter inside modal */}
      <MaterialHBModal
        show={modalShowAddProduct}
        onHide={() => hideModal()}
        allMaterialData={filterDropdownData.allData}
        existingGroups={existingGroups}
        existingGroupCodes={existingGroupCodes}
        existingCategories={existingCategories}
        existingSubCategories={existingSubCategories}
        groupComboList={groupComboList}
        categoryComboList={categoryComboList}
        subCategoryComboList={subCategoryComboList}
      />

      <CatalogProductDetailModal
        show={modalShowDetailProduct}
        onHide={() => hideModal()}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default Material;
